import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from "@/util/BASEAPI";
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import OCTextBox from './OCTextBox.vue'
import OCFormLabel from './OCFormLabel.vue'
import OCButtonSmall from './OCButtonSmall.vue'

export interface OCMailAuthenticationResponse {
    user: BASEAPI.User;
    email: string;
    code: string;
}

@Component({
    components: {
        OCTextBox, OCFormLabel, OCButtonSmall,
    },
})
export default class OCMailAuthentication extends Mixins(BASEComponentVue) {
    mode: number = 0
    error: string = "";
    kurukuru: boolean = false;

    email: string = "";
    code: string = "";
    element: HTMLElement = <HTMLElement>document.scrollingElement;

    @Emit("ok")
    public ok(val: OCMailAuthenticationResponse) {
        return val;
    };

    @Emit("back")
    public back() {
        return true;
    };

    public async check1() {
        this.error = "";
        this.kurukuru = true;
        try {
            let res = await BASEAPI.MailController.sendMailUsingPOST(this.email, <any>(this.langEnglish ? "en" : undefined)).catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                this.error = "" + res.data;
            } else {
                this.mode = 1;
            }
        } catch (error) {
            this.error = "" + error;
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public async check2() {
        this.error = "";
        this.kurukuru = true;
        try {
            let res = await BASEAPI.MailController.checkCodeUsingPOST(this.code).catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                this.error = "" + res.data;
            } else {
                let response: OCMailAuthenticationResponse = {
                    user: res.data,
                    email: this.email,
                    code: this.code
                }
                this.ok(response);
            }
        } catch (error) {
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public backButton(value: number) {
        this.mode = value;
        this.element.scrollTop = 0;
        this.error = "";
    }
}
